<template>
  <div>
    <div class="header header-fixed header-logo-center">
      <router-link to="/home" class="header-title color-theme">Book</router-link>
      <i  class="header-icon color-theme header-icon-4"><i
          class="fas fa-lightbulb"></i></i>
      <p class="header-icon header-icon-1">
        <i @click="$router.back()" class="fas fa-arrow-left"></i>
      </p>
    </div>
    <div v-if="!user.books.length" class="page-content header-clear-small">
      <p class="paragraph">
        To be able to read Shift Coaching Guide you have to pay your subscription at TBD offices.
      </p>
    </div>
    <div v-else class="page-content header-clear-small">
      <div class="mb-0">
        <p @click="previous" class="icon icon-s bg-facebook right-20 shadow-s"><i class="fa fa-arrow-left"></i></p>
        <p  class="icon icon-s  right-20 shadow-m ml-3 mr-3">{{currentPage}} / {{pageCount}}</p>
        <p @click="next" class="icon icon-s bg-facebook right-20 shadow-xl"><i class="fa fa-arrow-right"></i></p>
      </div>
      <pdf
          :page="currentPage"
          src="/sample.pdf"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"
      ></pdf>
    </div>

  </div>
</template>

<script>
import global from "@/mixins/global";
import pdf from 'vue-pdf'

export default {
  mixins: [global],
  
  components: {
    pdf
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 0,
    }
  },
  methods: {
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
      }
    },
    next(){
      if( this.currentPage < this.pageCount ){
        this.currentPage++
      }
    }
  }
}

</script>

<style>
.header2 {
  /*position: fixed;*/
  left: 0;
  right: 0;
  height: 50px;
  z-index: 99;
  transition: all 350ms ease;
  /*background-color: #fff;*/
  border-bottom: solid 1px rgba(0,0,0,.03);
  box-shadow: 0 4px 18px 0 rgba(0,0,0,.08);
}
.paragraph{
  padding: 10px;
}
</style>